import { useNativeBridge } from "@/hooks/useNativeBridge";
import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { FCC } from "@/types/common";

export const NativeBridgeProvider: FCC = ({ children }) => {
  const { ready } = useNativeBridge();

  if (!ready) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};
